import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      
      <section className="pt-32 pb-24" data-testid="terms-page">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <h1 className="text-4xl font-black uppercase tracking-tighter mb-8">Terms of Service</h1>
          
          <div className="prose prose-invert prose-sm max-w-none text-white/60">
            <p className="mb-6">Last updated: {new Date().toLocaleDateString()}</p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="mb-4">
              By accessing and using WrapViz, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our service.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">2. Description of Service</h2>
            <p className="mb-4">
              WrapViz provides a SaaS platform for vehicle wrap studios, including:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>White-label studio websites</li>
              <li>AI-powered wrap visualization</li>
              <li>Lead management tools</li>
              <li>Administrative dashboard</li>
            </ul>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">3. Subscription and Payment</h2>
            <p className="mb-4">
              The service is provided on a monthly subscription basis at $149/month. 
              Payments are processed securely through Stripe. You may cancel your subscription 
              at any time, effective at the end of your current billing period.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">4. User Content</h2>
            <p className="mb-4">
              You retain ownership of all content you upload. By uploading content, you grant 
              WrapViz a license to use, process, and display that content for the purpose of 
              providing our services.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">5. Acceptable Use</h2>
            <p className="mb-4">
              You agree not to:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Upload illegal, harmful, or offensive content</li>
              <li>Violate any intellectual property rights</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Use the service for any unlawful purpose</li>
            </ul>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">6. Limitation of Liability</h2>
            <p className="mb-4">
              WrapViz is provided "as is" without warranties of any kind. We are not liable 
              for any indirect, incidental, or consequential damages arising from your use 
              of the service.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">7. Changes to Terms</h2>
            <p className="mb-4">
              We may modify these terms at any time. Continued use of the service after 
              changes constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">8. Contact</h2>
            <p>
              For questions about these terms, contact us at:{' '}
              <a href="mailto:embermotors@gmail.com" className="text-[#FFFFFF] hover:underline">
                embermotors@gmail.com
              </a>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPage;
